import { Fragment, ReactNode, useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { DraftLoan } from '@roc/feature-types';
import { isNil } from '@roc/feature-utils';
import { useLoanStore } from '../../loans/hooks/useLoanStore';

const readApplication = (search: string) => {
  const params = new URLSearchParams(search);
  const loanApplicationId = Number(params.get('loanApplicationId'));
  const loanType = params.get('loanType');
  const loanSubType = params.get('loanSubType');
  if (!loanApplicationId || !loanType || !loanSubType) {
    return null;
  }
  return { loanApplicationId, loanType, loanSubType };
};

export const ContinueApplicationFromUrl = ({ children }: { children: ReactNode }) => {
  const { loanStore } = useLoanStore();
  const { pathname, search } = useLocation();
  const { replace } = useHistory();
  const seeded = useRef<{ loanApplicationId: number; key: number }>({ loanApplicationId: null, key: 0 });
  const application = readApplication(search);

  if (!isNil(application) && application.loanApplicationId !== seeded.current.loanApplicationId) {
    loanStore.continueDraftLoan(application as DraftLoan);
    seeded.current = { loanApplicationId: application.loanApplicationId, key: seeded.current.key + 1 };
  }

  useEffect(() => {
    if (!isNil(application)) {
      replace({ pathname, search: '' });
    }
  }, [search]);

  return <Fragment key={seeded.current.key}>{children}</Fragment>;
};
